import { api } from './client'

export type TipoDaRegra = 'Booleano' | 'Inteiro' | 'Lista'

/**
 * De onde veio o valor que está valendo.
 *
 * 🔴 Não é detalhe de tela. Sem a procedência, alguém edita o valor geral, nada
 * muda porque aquele assistente tem sobrescrita, e conclui que a tela está
 * quebrada — quando ela está certa e é a precedência que está em jogo.
 */
export type ProcedenciaDaRegra = 'Padrao' | 'Geral' | 'Assistente'

export type RegraDoCliente = {
  chave: string
  tipo: TipoDaRegra
  valor: string
  procedencia: ProcedenciaDaRegra

  /** O valor embutido no código, para o botão de "voltar ao padrão". */
  padrao: string

  /** O valor geral, quando a linha está sobrescrita no assistente. */
  geral: string | null

  descricao: string

  /**
   * O que passa a acontecer quando a booleana é desligada, em português e no
   * concreto. "Desativar a regra" não diz nada a quem decide.
   */
  efeitoAoDesligar: string | null

  /** Lista de que o motor depende não aceita vazio. */
  aceitaVazio: boolean
  minimo: number | null
  maximo: number | null

  atualizadoEm: string | null
  atualizadoPor: string | null
}

export const regras = {
  /** As oito, no nível geral. */
  gerais: () => api.get<RegraDoCliente[]>('/ia/regras'),

  gravarGeral: (chave: string, valor: string) =>
    api.put<{ chave: string; valor: string }>(`/ia/regras/${chave}`, { valor }),

  /** As oito com o valor efetivo daquele assistente, e a procedência de cada uma. */
  doAssistente: (marca: string, id: number) =>
    api.get<RegraDoCliente[]>(`/marcas/${marca}/assistentes/${id}/regras`),

  gravarNoAssistente: (marca: string, id: number, chave: string, valor: string) =>
    api.put<{ chave: string; valor: string }>(
      `/marcas/${marca}/assistentes/${id}/regras/${chave}`,
      { valor },
    ),

  /** Apaga a sobrescrita e devolve o valor geral. */
  usarOGeral: (marca: string, id: number, chave: string) =>
    api.delete<void>(`/marcas/${marca}/assistentes/${id}/regras/${chave}`),
}
